"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var APP_STATE_CONSTANTS;
(function (APP_STATE_CONSTANTS) {
    APP_STATE_CONSTANTS["BOOT"] = "0_aps_";
    APP_STATE_CONSTANTS["RESET"] = "1_aps_";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_BY_ID"] = "2_aps_";
    APP_STATE_CONSTANTS["ROUTING_SET_STACK"] = "3_aps_";
    APP_STATE_CONSTANTS["UPDATE_RUNNING_MODE"] = "4_aps_";
    APP_STATE_CONSTANTS["UPDATE_DB_CACHE"] = "5_aps_";
    APP_STATE_CONSTANTS["OVERWRITE_DB_CACHE"] = "6_aps_";
    APP_STATE_CONSTANTS["UPDATE_LOCAL_STORAGE"] = "7_aps_";
    APP_STATE_CONSTANTS["CLEAN_LOCAL_STORAGE"] = "8_aps_";
    APP_STATE_CONSTANTS["BOOT_LOCAL_STORAGE"] = "9_aps_";
    APP_STATE_CONSTANTS["CLEAN_LOCAL_STORAGE_LISTENERS"] = "a_aps_";
    APP_STATE_CONSTANTS["ADD_LOCAL_STORAGE_LISTENER"] = "b_aps_";
    APP_STATE_CONSTANTS["OPEN_CAMERA"] = "c_aps_";
    APP_STATE_CONSTANTS["UPDATE_INPUTDIALOG_CONTEXT"] = "d_aps_";
    APP_STATE_CONSTANTS["UPDATE_ALERT_CONTEXT"] = "e_aps_";
    APP_STATE_CONSTANTS["UPDATE_CONFIRM_ALERT_CONTEXT"] = "f_aps_";
    APP_STATE_CONSTANTS["UPDATE_ADMOB_INTERSTITIAL_CONTEXT"] = "g_aps_";
    APP_STATE_CONSTANTS["SET_IS_BOTTOM_MENU_OPENED"] = "h_aps_";
    APP_STATE_CONSTANTS["SET_IS_LOADING_PAGE_OPENED"] = "i_aps_";
    APP_STATE_CONSTANTS["SET_IS_SIDE_MENU_OPENED"] = "j_aps_";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_PROP_BY_PATH_IF_EXIST"] = "k_aps_";
    APP_STATE_CONSTANTS["UPDATE_CONTROL_TO_LIST"] = "l_aps_";
    APP_STATE_CONSTANTS["UPDATE_SWIPER_CONTENT"] = "m_aps_";
    APP_STATE_CONSTANTS["ADD_ITEMS_TO_FLAT_LIST"] = "n_aps_";
    APP_STATE_CONSTANTS["SET_CUSTOM_FONT_NAME"] = "o_aps_";
    APP_STATE_CONSTANTS["UPDATE_PALETTE_COLORS"] = "p_aps_";
    APP_STATE_CONSTANTS["SET_TRANSITION_SIDE_MENU"] = "q_aps_";
    APP_STATE_CONSTANTS["OPEN_IMAGE_VIEWER"] = "r_aps_";
})(APP_STATE_CONSTANTS || (APP_STATE_CONSTANTS = {}));
exports.default = APP_STATE_CONSTANTS;
